import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Estimates from '../views/Estimates';
import Constructor from '../views/Constructor';
import EstimateView from '../views/EstimateView';

Vue.use(VueRouter);

const routes = [
  {
    path: '/estimates/:id',
    name: 'SingleEstimate',
    props: true,
    component: EstimateView
  },
  {
    path: '/estimates',
    name: 'Estimates',
    component: Estimates,
  },
  {
    path: '/constructor',
    name: 'Constructor',
    component: Constructor,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    redirect: '/estimates'
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name != 'Login' && !localStorage.getItem('authToken')) {
    next({ name: 'Login', replace: true });
  } 
  else {
    if (to.name == 'Login' && localStorage.getItem('authToken')) {
      next({name: 'Estimates', replace: true});
    } else {
      next();
    }
  }
});

export default router;
